import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=0b7d4430&scoped=true"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d4430",
  null
  
)

export default component.exports